import { themeColors } from '@/theme/colors';
import { TextLink, Tooltip } from '@lego/connect-components-react';

const TOOLTIP_CONTENT_STYLE: React.CSSProperties = {
  display: 'flex',
  padding: '12px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  width: '220px',
  textAlign: 'left',
};

type RequiredFormatTooltipProps = {
  /**
   * Required columns. Pass a comma-separated string for inline text, or an
   * array of column names to render as a bulleted list.
   */
  columns: string | string[];
  position?: 'top' | 'bottom' | 'left' | 'right';
};

/**
 * Renders a "required format" text link that reveals the required columns in a
 * tooltip. Shared between the upload cards and the upload modals.
 */
const RequiredFormatTooltip = ({
  columns,
  position = 'bottom',
}: RequiredFormatTooltipProps) => (
  <Tooltip position={position}>
    <Tooltip.Trigger>
      <TextLink
        href="#"
        variant="emphasis"
        size="medium"
        style={{ textDecoration: 'none' }}
        onClick={(e) => e.preventDefault()}
      >
        required format
      </TextLink>
    </Tooltip.Trigger>
    <Tooltip.Content>
      <div style={TOOLTIP_CONTENT_STYLE}>
        Required columns:
        {Array.isArray(columns) ? (
          <ul style={{ margin: 0, paddingLeft: '16px' }}>
            {columns.map((column) => (
              <li key={column} className="label-xs-regular">
                {column}
              </li>
            ))}
          </ul>
        ) : (
          <span
            className="label-xs-regular"
            style={{ color: themeColors.content.subtle, lineHeight: 1.6 }}
          >
            {columns}
          </span>
        )}
      </div>
    </Tooltip.Content>
  </Tooltip>
);

export default RequiredFormatTooltip;
